/* ----------------- React Native Imports --------------- */
import type { ViewStyle } from "react-native";

/* ----------------- Third Party Imports --------------- */
import ContentLoader from "react-native-easy-content-loader";

interface DonutChartSkeletonProps {
	size?: number;
	isSmallScreen?: boolean;
	avatarStyle?: ViewStyle;
}
export const DonutChartSkeleton = ({
	size = 82,
	avatarStyle,
	isSmallScreen,
}: DonutChartSkeletonProps) => {
	return (
		//@ts-ignore
		<ContentLoader
			avatar
			title={false}
			pRows={0}
			avatarStyles={{ marginRight: 0, ...avatarStyle }}
			aSize={size}
			containerStyles={{
				width: size,
				paddingHorizontal: 0,
				alignSelf: isSmallScreen ? "center" : "flex-start",
			}}
		/>
	);
};
